import React from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";

export default function Back({location}) {
  const navigate = useNavigate();
  let page = "/home";

  if (location !== undefined) {
    page = location;
  }

  return (
    <>
      <ArrowBackIosIcon
        sx={{ fontSize: 25, color: "var(--pink)" }}
        onClick={() => navigate(page)}
      />
    </>
  );
}
